module.exports = __webpack_public_path__ + "ui-static/img/no-items_dark.33b79e0a.svg";